export class AddDocumentDialogConstants {
    static DOCUMENT_TYPE_LABEL = "Document type";
    static DESCRIPTION_LABEL = "Description";
    static FILE_LABEL = "File";
    static SELECT_FILE_LABEL = "Select file";
    static CANCEL_BTN_PLACEHOLDER = "Cancel";
    static DOCUMENT_TYPE_FORM_CONTROL = "documentType";
    static DESCRIPTION_FORM_CONTROL = "description";
    static FILE_NAME_FORM_CONTROL = "fileName";
    static SAVE_BTN_LABEL = "Save";
    static COMPONENT_NAME = "Edit attachment modal";
    static DOCUMENT_TYPE_ERR_MSG = "Please select the document type.";
    static DESCRIPTION_ERR_MSG = "Please enter a description for the document.";
    static NO_FILE_UPLOADED_ERR_MSG = "Please upload a document.";
    static UPLOADED_FILE_TOO_BIG_ERR_MSG = "The uploaded file size is bigger than the allowed file size";
    static UPLOADED_FILE_TYPE_NOT_ALLOWED_ERR_MSG = "The uploaded file type is not allowed.";
    static UPLOAD_ERROR_MSG = "Something went wrong uploading the selected attachment. please contact your system administrator.";
}
